import {chartColours} from "../../../themes/colours";

const layerDefs = {
    layer: {
        id: "catchment-area",
        type: "fill",
        paint: {
            "fill-color": chartColours.ldnDkPink,
            "fill-opacity": 0.7,
        },
        layout: {
            visibility: "none",
        },
    },

    overLayers: [
       {
        id: "catchment-line",
        type: "line",
        paint: {
            "line-color": chartColours.ldnDkPink,
            "line-width": 4,
        },
        layout: {
            visibility: "none",
        },
    }
    ],

    // this is set to be initially empty, as catchment for selected area is loaded as needed
    source: {
        id: "catchment-area",
        type: "geojson",
        data: {
            type: "FeatureCollection",
            features: [],
        },
    },

    labels: {
        parent: "Catchment Area",
    },

    "filters": {
        "filterByChildren": false
    },
    category: "hsds",
    requiresGis2Token: true,

    info: {
        shortDescription: "Core Catchment Area for Visitors.",
        longDescriptionTitle: "Core Area for Visitors",
        longDescription: [
            (<><strong>Visitor and spend information is only available to members of
                the High Streets Data Service (HSDS).</strong> For members the login
                button is at the bottom right of the sidebar.</>),
            (<><strong>Core Catchment Area</strong>: Shows the ‘reach’ of the chosen
                High Street, Town Centre or BID out into the local community. The line
                was created by taking the top 50% of home locations for visitors. Can be
                used to</>),
            (<ul>
                <li>compare with the theoretical travel catchment with actual
                    behaviour</li>
                <li>allow visual analysis of the demographic LOAC layer, to see what
                    types of communities it serves</li>
            </ul>),
            (<>The home location and destination uses anonymised and aggregated BT
                mobile phone data. Visitor and spend figures are a historical average
                representing typical values for the selected time band. The historical
                average is derived from 12 consecutive months of data collected within
                the last 18 months.</>),
            (<>Full dataset and methodology are available here: <a
                href="https://data.london.gov.uk/dataset/footfall-bt-people-counts-hsds"
                target="_blank"
                rel="noopener noreferrer">https://data.london.gov.uk/dataset/footfall-bt-people-counts-hsds</a>
            </>),
        ]
    }
};

export default layerDefs;